import {FacePhoto} from 'presentation/pages/others/facial-biometrics/pages';
import React from 'react';

export const MakeFacePhoto: React.FC = () => <FacePhoto />;
